export default __webpack_public_path__ + "static/media/searchWhite.ebd7c503.svg";